import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortDuration',
  pure: false,
  standalone: true
})
export class ShortDurationPipe implements PipeTransform {
  // if start date and end date passed, return time difference in format 1d 2h 3m 4s and 
  // if end date not passed, current time is taken as end date and return time difference
  transform(start: Date | string | null | undefined, end?: Date | string | null): string {
    if (!start) {
      return '--';
    }
    if (!end && typeof start === 'string') {
      start = (start.endsWith('Z') || start.endsWith('z')) ? start : start + 'Z';
    }
    const endTime = end ? new Date(end) : new Date();
    const diffMs = Math.abs(endTime.getTime() - new Date(start).getTime());
    const totalSeconds = Math.floor(diffMs / 1000);

    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (days > 0) {
      return `${days}d ${hours}h ${minutes}m ${seconds}s`;
    }
    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`;
    }
    if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    }
    return `${seconds}s`;
  }
}